enum Currency {
  CAD = 'CAD',
  USD = 'USD',
}

export default Currency;
export type VerifyCurrency = Utils.VerifyExtends<Model.Enum.Currency, Utils.ValueOf<typeof Currency>>;
